<template>
  <div id="homeDemo">
    <div v-if="viewType === 'card'">
      <div v-if="resultDemoAccountList.length !== 0" class="account_card_box">
        <el-row :gutter="20">
          <el-col :lg="8" :xs="24" v-for="item in resultDemoAccountList" :key="item.index">
            <div class="card_item">
              <div class="item_top">
                <div class="item_top_l">
                  <div
                    class="platform_tag"
                    :style="item.status === 'Expired' ? 'background-color: #979797;' : ''"
                    :class="[item.specialPlatformType === 4 ? 'platform_mt4' : 'platform_mt5']"
                  >
                    {{
                      item.specialPlatformType === 4
                        ? 'MT4'
                        : item.mt4_account_type >= 99 && item.mt4_account_type <= 115
                        ? 'Copy Trading'
                        : 'MT5'
                    }}
                  </div>
                  <span
                    :style="item.status === 'Expired' ? 'color: #979797;' : ''"
                    class="acc_num"
                    v-if="item.accNum !== '--'"
                    >{{ item.accNum }}</span
                  >
                </div>
                <div class="item_top_r" v-if="item.status !== 'Active'">
                  <span class="dot" :class="['dot_' + item.status]"></span>
                  <span :class="'font_' + item.status">{{ item.status }}</span>
                </div>
              </div>
              <div class="item_center">
                <div class="center_l">
                  <div class="center_l_data">
                    <img :src="item.currencyLogo" class="center_logo" alt="" />
                    <span v-if="item.status === 'Active'" class="center_num">
                      {{ formatNumber(item.equity) }}
                      <span class=""> {{ item.currency }}</span>
                    </span>
                    <span
                      v-else
                      class="center_num"
                      style="font-weight: 600"
                      :style="item.status === 'Expired' ? 'color: #979797;' : ''"
                      >--</span
                    >
                  </div>
                </div>
              </div>
              <div class="item_divider"></div>
              <div class="item_bottom" :style="item.status === 'Expired' ? 'color: #979797;' : ''">
                <div class="item_bottom_content">
                  {{ $t('common.column.leverage') }}
                  <span v-if="item.leverage">: {{ item.leverage }}:1 </span>
                  <span v-else>: -</span>
                </div>
                <div class="item_bottom_content">
                  {{ $t('common.column.type') }}: {{ $config.accountTypeMaps[item.accMt4Type] }}
                </div>
                <div class="item_bottom_content">
                  <span v-if="item.server">{{ $t('common.column.server') }}: {{ item.server }}</span>
                  <span v-else>{{ $t('common.column.server') }}: -</span>
                  <div class="setting_box" v-if="item.status === 'Active'">
                    <el-popover placement="bottom" popper-class="pop_content" trigger="click">
                      <div class="popover_btn_list">
                        <div class="pbl_item" v-if="item.status === 'Active'">
                          <el-button @click="resetBalClick(item)">
                            <svg-icon iconName="reset-bal-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.column.resetBal') }}</span>
                          </el-button>
                        </div>
                        <div class="pbl_item">
                          <el-button v-if="item.leverage" @click.stop.prevent="openLeverageDemo(item)">
                            <svg-icon iconName="filter-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.button.changeLeverage') }}</span>
                          </el-button>
                        </div>
                        <div class="pbl_item">
                          <el-button v-if="item.status === 'Active'" @click.stop.prevent="handleLock(item.index, item)">
                            <svg-icon iconName="unlock-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.button.changePw') }}</span>
                          </el-button>
                        </div>
                      </div>
                      <span slot="reference" class="setting_icon">
                        <svg-icon iconName="setting-icon"></svg-icon>
                      </span>
                    </el-popover>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="no_data_box" v-else>
        <div><img src="@/assets/images/nodata_icon.png" width="70" /></div>
        <div class="no_data_font mt-3">{{ $t('loyalty.noData') }}</div>
      </div>
    </div>
    <div v-if="viewType === 'list'">
      <div class="table_list_box mt-6">
        <div class="table_item_box">
          <div class="table_box">
            <el-table :data="resultDemoAccountList">
              <el-table-column :label="$t('common.column.accNum')" prop="accNum" min-width="120"></el-table-column>
              <el-table-column
                show-overflow-tooltip
                :label="$t('common.column.server')"
                prop="server"
                min-width="180"
              ></el-table-column>
              <el-table-column :label="$t('common.column.platform')" min-width="100">
                <template slot-scope="scope">MT{{ scope.row.specialPlatformType }}</template>
              </el-table-column>
              <el-table-column :label="$t('common.column.type')" min-width="120">
                <template slot-scope="scope">
                  {{ $config.accountTypeMaps[scope.row.accMt4Type] }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.column.currency')" prop="currency" min-width="100"></el-table-column>
              <el-table-column :label="$t('common.column.equity')" min-width="130">
                <template slot-scope="scope">{{ scope.row.equity | formatNumber }}</template>
              </el-table-column>
              <el-table-column :label="$t('common.column.leverage')" min-width="140">
                <template slot-scope="scope">
                  <div v-if="scope.row.status !== 'Expired'">{{ scope.row.leverage }} : 1</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('common.column.status')" prop="status" min-width="100"> </el-table-column>
              <el-table-column :label="$t('common.column.setting')" prop="status" min-width="120">
                <template slot-scope="scope">
                  <div class="setting_box" v-if="scope.row.status === 'Active'">
                    <el-popover placement="bottom" popper-class="pop_content" trigger="click">
                      <div class="popover_btn_list">
                        <div class="pbl_item" v-if="scope.row.status === 'Active'">
                          <el-button @click="resetBalClick(scope.row)">
                            <svg-icon iconName="reset-bal-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.column.resetBal') }}</span>
                          </el-button>
                        </div>
                        <div class="pbl_item">
                          <el-button v-if="scope.row.leverage" @click.stop.prevent="openLeverageDemo(scope.row)">
                            <svg-icon iconName="filter-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.button.changeLeverage') }}</span>
                          </el-button>
                        </div>
                        <div class="pbl_item">
                          <el-button
                            v-if="scope.row.status === 'Active'"
                            @click.stop.prevent="handleLock(scope.$index, scope.row)"
                          >
                            <svg-icon iconName="unlock-icon"></svg-icon>
                            <span class="more_btn_text">{{ $t('common.button.changePw') }}</span>
                          </el-button>
                        </div>
                      </div>
                      <span slot="reference" class="table_setting_icon">
                        <svg-icon iconName="setting-icon"></svg-icon>
                      </span>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
              <div slot="empty" class="empty">
                <img class="noData_icon" src="@/assets/images/no_data.png" alt />
                <div>{{ $t('loyalty.noData') }}</div>
              </div>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Home from '@/components/template/Home';
import Common from '@/components/home/Common';
import { apiHomeGet_demo_accs, apiReq_reset_mt4_password } from '@/resource';
import { RegisterRoutePath } from '@/router/registerRoutes';
import { formatNumber } from '@/util/filter';

export default {
  components: { Home, Common },
  props: {
    viewType: {
      type: String,
      default: 'card'
    },
    resultDemoAccountList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      uuid: this.$store.state.common.uuid,
      mt4AccountTableData: [],
      mt5AccountTableData: [],
      allMetaDemoAccounts: [],
      passwordVisible: false,
      changePasswordVisible: false,
      pwdConfirmVisible: false,
      forgotPwdVisible: false,
      resetBalVisible: false,
      number: null,
      isDemo: true
    };
  },
  created() {
    this.registerPath = RegisterRoutePath.register;
  },
  mounted() {
    this.getDemo();
  },
  methods: {
    formatNumber,
    getDemo() {
      apiHomeGet_demo_accs().then(resp => {
        this.allMetaDemoAccounts = resp.data.data || [];
        this.formatAccounts();
      });
    },
    formatAccounts() {
      this.mt4AccountTableData = [];
      this.mt5AccountTableData = [];
      this.allMetaDemoAccounts.map(m => {
        m.platform == '4' ? this.mt4AccountTableData.push(m) : this.mt5AccountTableData.push(m);
      });
    },
    handleLock(index, row) {
      //   this.passwordVisible = true;
      this.number = parseInt(row.accNum);
      this.$emit('update:passwordVisible', true);
      this.$emit('update:number', this.number);
    },
    forgotPwdClick() {
      this.sendResetPasswordEmail().then(result => {
        let vm = this;
        if (result) {
          this.passwordVisible = false;
          this.forgotPwdVisible = true;
        } else {
          this.$message({
            message: vm.$t('home.pw.error'),
            type: 'error'
          });
        }
      });
    },
    resetBalClick(row) {
      this.number = parseInt(row.accNum);
      this.$emit('update:resetBalVisible', true);
      this.$emit('update:number', this.number);
    },
    sendResetPasswordEmail() {
      const baseUrl = location.protocol + '//' + location.hostname;
      return apiReq_reset_mt4_password({
        userId: this.uuid,
        mtAccount: this.number,
        baseUrl: baseUrl,
        isDemo: this.isDemo
      }).then(resp => {
        if (resp.data.code == 0) {
          if (resp.data.data) {
            console.log('The reset password email is sent out');
            return Promise.resolve(true);
          } else {
            console.log('failed to sent out the reset password');
          }
        } else {
          console.log('Errors happened when applying for the reset password emails');
        }
        return Promise.resolve(false);
      });
    },
    openLeverageDemo(element) {
      this.$emit('triggerLeverageDemo', element);
    }
  },
  computed: {
    checkRegisterStep() {
      return this.$store.state.common.registerStep < 5;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/home.scss';
</style>
